import { FilterOption } from '../../__generated__/chirp/com/hubspot/marketplace/storefront/service/rpc/MarketplaceStorefrontRpc';
import { Filter } from './hooks/useFilterConfig';

export function getFlattenedOptions(filter: Filter) {
  return filter.options.length > 0
    ? filter.options
    : filter.optionGroups.flatMap((group) => group.options);
}

export function findOptionText(
  options: readonly FilterOption[],
  value: string
) {
  return options.find((o) => o.value === value)?.text;
}
